import { createFileRoute } from "@tanstack/react-router";
import { MentionsInbox } from "@/components/app/mentions/mentions-inbox";
import { AtSign } from "@/lib/icons";
import { InboxBackButton } from "../-components/home/inbox-back-button";

export const Route = createFileRoute("/_authenticated/messaging/_inbox/mentions")({
  component: MentionsInMessaging,
});

/** Where someone named you, in notes, tasks and messages alike, kept with the rest of messaging. */
function MentionsInMessaging() {
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <header className="flex items-center gap-2 border-b px-3 py-2 md:px-4">
        <InboxBackButton />
        <AtSign className="text-muted-foreground size-4" />
        <h1 className="text-sm font-semibold">Mentions</h1>
      </header>
      <div className="min-h-0 flex-1 space-y-4 overflow-y-auto px-4 py-4">
        <MentionsInbox inline />
      </div>
    </div>
  );
}
